export default "__VITE_ASSET__DahNbXXD__"